
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const JobsPage = lazy(() => import('../pages/jobs/page'));
const JobDetailPage = lazy(() => import('../pages/job-detail/page'));
const EmployerPage = lazy(() => import('../pages/employer/page'));
const CompanyReviewsPage = lazy(() => import('../pages/company-reviews/page'));
const SalaryGuidePage = lazy(() => import('../pages/salary-guide/page'));
const WhyZingPage = lazy(() => import('../pages/why-zing/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/jobs',
    element: <JobsPage />
  },
  {
    path: '/jobs/:id',
    element: <JobDetailPage />
  },
  {
    path: '/employer',
    element: <EmployerPage />
  },
  {
    path: '/company-reviews',
    element: <CompanyReviewsPage />
  },
  {
    path: '/salary-guide',
    element: <SalaryGuidePage />
  },
  {
    path: '/why-zing',
    element: <WhyZingPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
